export const hasSystemPermissions = (
    availableScopes: string[] | null | undefined,
    requiredScopes: string[],
    errors?: string[]
): boolean => {
    const resolvedErrors = errors || []
    const availableScopesSet = new Set(availableScopes || [])

    requiredScopes.forEach((scope) => {
        if (!availableScopesSet.has(scope)) {
            resolvedErrors.push(scope)
        }
    })

    return resolvedErrors.length === 0
}
